import { fetch } from "@/utils/fetch";

const apis = {
  login: { url: "/User/login", type: "post" },
  createVideo: { url: "/Video", type: "post" },
  updateVideo: { url: "/Video/{id}", type: "put" },
  getVideos: { url: "/Video", type: "get" },
  getVideoById: { url: "/Video/{id}", type: "get" },
  getAuth: { url: "http://www.chenrysoft.com:90/account/setp0", type: "post" },
  // getAuth: { url: "/chenrry/account/setp0", type: "post" },
  sendCode: {
    url: "http://www.chenrysoft.com:90/account/setp1",
    // url: "/chenrry/account/setp1",
    type: "post"
  },
  validationCode: {
    url: "http://www.chenrysoft.com:90/account/setp2",
    // url: "/chenrry/account/setp2",
    type: "post"
  },
  submitData: {
    url: "http://www.chenrysoft.com:90/account/setp3",
    // url: "/chenrry/account/setp3",
    type: "post"
  },
  // 忘记密码相关接口
  fGetAuth: { url: "http://www.chenrysoft.com:90/account/fsetp0", type: "post" },
  // fGetAuth: { url: "/chenrry/account/fsetp0", type: "post" },
  fSendCode: {
    url: "http://www.chenrysoft.com:90/account/fsetp1",
    // url: "/chenrry/account/fsetp1",
    type: "post"
  },
  fValidationCode: {
    url: "http://www.chenrysoft.com:90/account/fsetp2",
    // url: "/chenrry/account/fsetp2",
    type: "post"
  },
  fSubmitData: {
    url: "http://www.chenrysoft.com:90/account/fsetp3",
    // url: "/chenrry/account/fsetp3",
    type: "post"
  },
  getVideosH5ById: { url: "/Video/h5/{id}", type: "get" },
  getVideosByKey: { url: "/Video/bykey", type: "get" },
  deleteVideo: { url: "/Video/{id}", type: "delete" },
  createDownloadAttachment: { url: "/DownloadAttachment", type: "post" },
  updateDownloadAttachment: { url: "/DownloadAttachment/{id}", type: "put" },
  getDownloadAttachments: { url: "/DownloadAttachment", type: "get" },
  getDownloadAttachmentById: { url: "/DownloadAttachment/{id}", type: "get" },
  getDownloadAttachmentsH5ById: {
    url: "/DownloadAttachment/h5/{id}",
    type: "get"
  },
  getDownloadAttachmentsByKey: {
    url: "/DownloadAttachment/bykey",
    type: "get"
  },
  deleteDownloadAttachment: { url: "/DownloadAttachment/{id}", type: "delete" },

  getUpdateRecordListById: { url: "/UpdateRecord/getlist", type: "get" },
  getUpdateRecordById: { url: "/UpdateRecord/{id}", type: "get" },
  deleteUpdateRecord: { url: "/UpdateRecord/{id}", type: "delete" },
  createUpdateRecord: { url: "/UpdateRecord", type: "post" },
  updateUpdateRecord: { url: "/UpdateRecord/{id}", type: "put" }
};

const list = {};
// const domain = "/api";
const domain = "/server/api";

Object.keys(apis).forEach(e => {
  const curr = apis[e];
  list[e] = function (data) {
    let url = curr.url;
    const config = { method: curr.type, silent: curr.silent, headers: {} };
    const curEnv = process.env
    if (curr.url.indexOf("http://www") === -1) {
      url = domain + curr.url;
    } else {
      if (curEnv === 'development') {
        url = curr.url.replace('http://www.chenrysoft.com:90', '/chenrry')
      }
      config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    }
    if (curr.type === "get") {
      config.params = data;
    } else {
      config.data = data;
    }
    return fetch(url, config);
  };
});

// ajax 全局库入口
const apiPlugin = {
  install (V) {
    V.prototype.apis = list;
  }
};

export { list as apis, apiPlugin };
